import { z } from 'zod';
import { http } from '@/lib/ats-https';
import { AiScoringSchemas } from '../../api/aiScoring.schema';
import { AxiosRequestConfig } from 'axios';

/**  validate attributes  api with zod schema */
const _validateAttributesPayloadSchema = z.object({
  ai_scoring: z.object({
    retrigger: z.boolean().optional(),
    should_save: z.boolean().optional(),
    attributes: z.array(AiScoringSchemas.AiScoringAttributeSchema),
  }),
});

const validateAttributesResponseSchema = z.object({
  data: z
    .object({
      status: z.enum(['pending', 'success', 'error']).optional(),
      result_key: z.string().optional(),
      attributes: z.array(AiScoringSchemas.AiScoringAttributeSchema).optional(),
    })
    .optional(),
  errors: z.array(z.any()),
});

const BASE = '/ats_jobs';

async function validateAttributes(
  atsJobId: string,
  payload: z.infer<typeof validateAttributesPayloadSchema>
): Promise<{
  data?: z.infer<typeof validateAttributesResponseSchema>;
  error?: Error;
}> {
  try {
    const response = await http.put(
      `${BASE}/${atsJobId}/ai_scoring/attributes/validate`,
      payload
    );
    try {
      const data = validateAttributesResponseSchema.parse(response);
      return { data };
    } catch (error) {
      console.log('🔄 Zod validation error validateAttributes:', error);
      return { error: error as Error };
    }
  } catch (error) {
    return { error: error as Error };
  }
}

/**  validate attributes status api with zod schema */

const validateAttributesStatusResponseSchema = z.object({
  data: z.object({
    status: z.enum(['pending', 'success', 'error']),
    error: z.string().optional(),
    result_key: z.string(),
    icp: z.string().optional(),
    attributes: z.array(AiScoringSchemas.AiScoringAttributeSchema).optional(),
  }),
  errors: z.array(z.any()),
});

async function validateAttributesStatus(
  atsJobId: string,
  aiScoringId: string
): Promise<{
  data?: z.infer<typeof validateAttributesStatusResponseSchema>;
  error?: Error;
}> {
  try {
    const response = await http.get(
      `${BASE}/${atsJobId}/ai_scoring/attributes/${aiScoringId}/status`
    );
    try {
      const data = validateAttributesStatusResponseSchema.parse(response);
      return { data };
    } catch (error) {
      console.log('🔄 Zod validation error validateAttributesStatus:', error);
      return { error: error as Error };
    }
  } catch (error) {
    return { error: error as Error };
  }
}

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  fullResponse?: boolean;
}

// todo: need to handle retrigger
const saveAttributesFromCache = async (
  atsJobId: string,
  retrigger: boolean = false
): Promise<{
  data?: any;
  error?: Error;
  status?: number;
  errors?: any[];
}> => {
  try {
    const response = await http.put(
      `${BASE}/${atsJobId}/ai_scoring/attributes/save`,
      { ai_scoring: { retrigger } },
      { fullResponse: true } as CustomAxiosRequestConfig
    );
    // since there is no response from the server, skip zod parsing
    return {
      data: response.data,
      status: response.status,
      errors: response.data.errors || [],
    };
  } catch (error) {
    return { error: error as Error };
  }
};

export const aiAttributeApi = {
  saveAttributesFromCache,
  validateAttributes,
  validateAttributesStatus,
};
